.messageBox {
  position: fixed;
  z-index: 1100;
  bottom: var(--bottom-nav-menu-height);
  width: 100%;
  background-color: #fff;
  padding: 8px 16px;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
}
